<div class="valign-wrapper white-text" style="height: 75vh;">
    <h5 style="margin-left: 42%" translate>logout.thankYou</h5>
</div>
